import React, { useEffect, useState, useRef } from 'react';
import { __ } from '@wordpress/i18n';
import { useDispatch, useSelector } from 'react-redux';
import { queryNavigation, queryParamDelete } from '../utils/query-navigation';
import ICONS from '../icons';

import './style.scss';

const SiteFiltersCombined = ( { crossIconClick } ) => {
	const { filtersortby, filterplan, pageBuilder } = useSelector(
		( state ) => state
	);
	const dispatch = useDispatch();
	const [ toggle, setToggle ] = useState( false );
	const ref = useRef();
	const [ selectedPageBuilder, setSelectedPageBuilder ] = useState( pageBuilder );
	const [ selectedFilterPlan, setSelectedFilterPlan ] = useState(
		filterplan === '' ? 'all' : filterplan
	);
	const [ selectedSortBy, setSelectedSortBy ] = useState( filtersortby );

	const siteType = [
		{
			id: 'all',
			title: __( 'All' ),
		},
		{
			id: 'agency-mini',
			title: __( 'Premium' ),
		},
		{
			id: 'signature',
			title: __( 'Signature', 'astra-sites-showcase' ),
		},
	];

	const siteOrder = [
		{
			id: 'popular',
			title: __( 'Popular' ),
		},
		{
			id: 'latest',
			title: __( 'Latest' ),
		},
	];

	const buildersList = [
		{
			id: 'elementor',
			title: __( 'Elementor', 'astra-sites-showcase' ),
			image: `${ AstraShowcaseVars.image_dir }elementor.svg`,
		},
		{
			id: 'gutenberg',
			title: __( 'Spectra', 'astra-sites-showcase' ),
			image: `${ AstraShowcaseVars.image_dir }spectra.svg`,
		},
	];

	const handleToggle = ( event ) => {
		event.preventDefault();
		crossIconClick( event );
		setToggle( ( prev ) => ! prev );
	};

	const handleToggleOutsideClick = ( event ) => {
		if ( ref && ! ref.current.contains( event.target ) ) {
			setToggle( false );
		}
	};

	const handlePageBuilderSelect = ( event ) => {
		const type = event.target.value;
		setSelectedPageBuilder( type );
	};

	const handleSiteTypeSelect = ( event ) => {
		const type = event.target.value;
		setSelectedFilterPlan( type );
	};

	const handleSiteOrderBySelect = ( event ) => {
		const type = event.target.value;
		setSelectedSortBy( type );
	};

	const handleCancelButtonClick = () => {
		setToggle( false );
	};

	const handleApplyButtonClick = () => {
		dispatch( {
			type: 'set',
			pageBuilder: selectedPageBuilder,
			filterplan: selectedFilterPlan === 'all' ? '' : selectedFilterPlan,
			filtersortby: selectedSortBy,
			searchTerm: '',
		} );
		queryNavigation( 'page-builder', selectedPageBuilder );
		if ( selectedFilterPlan === 'all' ) {
			queryParamDelete( 'type' );
		} else {
			queryNavigation( 'type', selectedFilterPlan );
		}
		setToggle( false );
		const element = document.getElementById( 'astra-sites-grid' );
		if ( element ) {
			// Create a new element positioned -100px above the target element
			const offsetElement = document.createElement( 'div' );
			offsetElement.style.height = '100px';
			element.parentNode.insertBefore( offsetElement, element );

			// Scroll to the offset element with smooth behavior
			offsetElement.scrollIntoView( { behavior: 'smooth' } );

			// Remove the offset element after scrolling
			setTimeout( () => {
				offsetElement.parentNode.removeChild( offsetElement );
			}, 2000 ); // 2000 milliseconds = 2 second
		}
	};

	useEffect( () => {
		document
			.querySelector( 'body' )
			.addEventListener( 'click', handleToggleOutsideClick );

		return () =>
			document
				.querySelector( 'body' )
				.removeEventListener( 'click', handleToggleOutsideClick );
	}, [] );

	return (
		<div ref={ ref } className="st-site-filters-combined-wrapper">
			<div
				onClick={ handleToggle }
				className={ `st-site-filters-combined-label ${
					toggle ? 'opened' : 'closed'
				}` }
			>
				{ ICONS.filter }
			</div>
			{ toggle && (
				<div className="directory-filter-section">
					<div className="st-site-filters-combined-popup">
						<div className="st-site-filters-combined-page-type">
							<span className="st-site-filter-type-label">
								By Page Builder
							</span>
							{ buildersList.map( ( type ) => (
								<label
									key={ type.id }
									className={ `st-site-filters-combined-input-label ${
										selectedPageBuilder === type.id
											? 'active'
											: ''
									}` }
									htmlFor={ type.id }
									onClick={ handlePageBuilderSelect }
								>
									<input
										key={ type.id }
										className="st-site-filters-combined-input"
										type="radio"
										name="page-builder"
										id={ type.id }
										value={ type.id }
										checked={
											selectedPageBuilder === type.id
										}
										onChange={ () => {} } //Added this empty callback to bypass react warnings in console.
									/>
									<img
										src={ type.image }
										className="stc-logo-image"
										alt={ type.id }
									/>
									{ type.title }
								</label>
							) ) }
						</div>

						<div className="st-site-filters-combined-site-type">
							<span className="st-site-filter-type-label">
								By Type
							</span>
							{ siteType.map( ( type ) => (
								<label
									key={ type.id }
									className={ `st-site-filters-combined-input-label ${
										selectedFilterPlan === type.id
											? 'active'
											: ''
									}` }
									htmlFor={ type.id }
									onClick={ handleSiteTypeSelect }
								>
									<input
										key={ type.id }
										className="st-site-filters-combined-input"
										type="radio"
										name="site-type"
										value={ type.id }
										id={ type.id }
										checked={ selectedFilterPlan === type.id }
										onChange={ () => {} } //Added this empty callback to bypass react warnings in console.
									/>
									{ type.title }
								</label>
							) ) }
						</div>

						<div className="st-site-filters-combined-order-by">
							<span className="st-site-filter-type-label">
								Sort By
							</span>
							{ siteOrder.map( ( order ) => {
								return (
									<label
										key={ order.id }
										className={ `st-site-filters-combined-input-label ${
											selectedSortBy === order.id
												? 'active'
												: ''
										}` }
										htmlFor={ order.id }
										onClick={ handleSiteOrderBySelect }
									>
										<input
											key={ order.id }
											className="st-site-filters-combined-input"
											type="radio"
											name="order-by"
											value={ order.id }
											id={ order.id }
											checked={
												selectedSortBy === order.id
											}
											onChange={ () => {} } //Added this empty callback to bypass react warnings in console.
										/>
										{ order.title }
									</label>
								);
							} ) }
						</div>
					</div>
					<div className="action-section">
						<button
							className="button-primary button"
							onClick={ handleApplyButtonClick }
						>
							Apply
						</button>
						<button
							className="button-close button"
							onClick={ handleCancelButtonClick }
						>
							Cancel
						</button>
					</div>
				</div>
			) }
		</div>
	);
};

export default SiteFiltersCombined;
